import React, { useRef, useState, useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { GeoMap } from '../geoMap/GeoMap';

export const GeoPoint: any = (props: any) => {
  const {
    position,
    center,
    zoom,
    draggable = true,
    showUserPosition = false,
  } = props;
  const flags = useFlags();
  const [positionId, setPositionId] = useState<any>();
  const markerRef = useRef(null) as any;
  const userPositionIconRef = useRef(null) as any;
  const mapRef = useRef(null) as any;
  const mapsRef = useRef(null) as any;

  const handleApiLoaded = ({ map, maps }: any) => {
    mapRef.current = map;
    mapsRef.current = maps;
    if (position?.lat && position?.lng) {
      addMarker({ map, maps }, position);
    }
    if (showUserPosition && flags?.showUserPosition) {
      navigator.geolocation.getCurrentPosition(function(userPosition) {
        addUserIcon({ map }, { lat: userPosition.coords.latitude, lng: userPosition.coords.longitude });
        const bounds = new maps.LatLngBounds();
        bounds.extend(position);
        bounds.extend({ lat: userPosition.coords.latitude, lng: userPosition.coords.longitude });
        map.fitBounds(bounds);
      });
      const id = navigator.geolocation.watchPosition(function(position) {
        addUserIcon({ map }, { lat: position.coords.latitude, lng: position.coords.longitude });
      });
      setPositionId(id);
    }
  };

  useEffect(() => {
    return () => {
      navigator.geolocation.clearWatch(positionId);
    };
  }, [positionId]);
  const addMarker = ({ map, maps }: any, position: any) => {
    if (markerRef.current) {
      markerRef.current.setMap(null);
    }

    markerRef.current = new maps.Marker({
      position,
      map,
      draggable,
    });
  };

  const addUserIcon = ({ map }: any, position: any) => {
    if (userPositionIconRef.current) {
      userPositionIconRef.current.setMap(null);
    }
    userPositionIconRef.current = new google.maps.Marker({
      position,
      icon: {
        anchor: new google.maps.Point(16, 16),
        url: 'data:image/svg+xml;utf-8, \
        <svg width="48" height="48" viewBox="0 0 40 40"  xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="8" fill="none" stroke="rgb(0, 131, 168)" stroke-width="2"><animate attributeName="r" begin="0s" dur="1.5s" from="8" repeatCount="indefinite" to="20"/><animate attributeName="opacity" begin="0s" dur="1.5s" from="1" repeatCount="indefinite" to="0"/></circle><circle cx="20" cy="20" r="10" fill="rgb(0, 131, 168)"/></svg>',
      },
      map: map,
    });
  };
  return (
    <div>
      <GeoMap
        className="geo-map"
        position={position}
        handleApiLoaded={handleApiLoaded}
        center={center}
        zoom={zoom}
      />
    </div>
  );
};
